import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]

interface Props {
  tabs: Tab<T>[];
  modelValue: T;
}

export interface Tab<T> {
  value: T;
  title: string;
  titleShort: string;
}

interface Emits {
  (event: 'update:model-value', tab: T): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    tabs: {},
    modelValue: {}
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

function select(tab: Tab<T>): void {
  emit('update:model-value', tab.value);
}

function selected(tab: Tab<T>): boolean {
  return tab.value === props.modelValue;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tabs, (tab) => {
      return (_openBlock(), _createElementBlock("div", {
        onClick: ($event: any) => (select(tab)),
        class: _normalizeClass(["px-4 py-3", [
        selected(tab) ? 'border-b-2 border-primary text-neutral2-700' : '',
        selected(tab) ? 'cursor-default' : 'cursor-pointer',
      ]])
      }, [
        _createElementVNode("span", {
          class: "max-md:hidden",
          textContent: _toDisplayString(tab.title)
        }, null, 8 /* PROPS */, _hoisted_3),
        _createElementVNode("span", {
          class: "md:hidden",
          textContent: _toDisplayString(tab.titleShort)
        }, null, 8 /* PROPS */, _hoisted_4)
      ], 10 /* CLASS, PROPS */, _hoisted_2))
    }), 256 /* UNKEYED_FRAGMENT */))
  ]))
}
}

})